import { render, staticRenderFns } from "./DisclosureObservations.vue?vue&type=template&id=29926294&scoped=true&"
import script from "./DisclosureObservations.vue?vue&type=script&lang=ts&"
export * from "./DisclosureObservations.vue?vue&type=script&lang=ts&"
import style0 from "./DisclosureObservations.vue?vue&type=style&index=0&id=29926294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29926294",
  null
  
)

export default component.exports